{{title}}
<fa-icon [icon]="closeIcon" (click)="close()" class="cursor-pointer"></fa-icon>
